import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import {
	getOrderDetail,
	check,
	updateShipFee,
	updateInprice,
	updateNum,
	updateShipNo,
	cancelOrder,
	updateRemark
} from '@/api/sms/arrival-order';
import {wait} from '@/utils/wait';
import {Message} from 'element-ui';
export default extend(dialog, {
	namespaced: true,
	state: {
		id: 0,
		type: 1,
		detail: {},
		list: [],
		multipleSelection: [],
		opLogList: []
	},
	actions: {
		async afterOpenDialog({dispatch, commit, state}, payload) {
			document.activeElement.blur()
			const {id, type} = state;
			commit('save', {
				multipleSelection: []
			})
			await wait(dispatch, 'sms.arrival-order.detail', async function () {
				const response = await getOrderDetail(id, {
					queryType: type
				});
				if (response.data) {
					commit('save', {
						detail: response.data.deliverOrderInfo,
						opLogList: response.data.opLogList,
						list: (response.data.goodsList || []).map((v) => {
							const canCheckNum = v.deliveredNum - v.checkedNum - v.expNum;
							return {
								...v,
								curCheckNum: 0,
								canCheckNum: canCheckNum,
								storageLocation: ""
							}
						})
					})
				}
			})
		},
		async check({dispatch, commit, state}, payload) {
			const {detail: {deliveredOrderId}} = state;
			const {goodsId, storageLocation, curCheckNum, recId} = payload;
			await wait(dispatch, `sms.arrival-order.check.${goodsId}`, async function () {
				const response = await check(deliveredOrderId, {
					checkList: [{
						deliveredOrderGoodsId: recId,
						curCheckNum,
						storageLocation
					}]
				});
				if (response.data) {
					Message.success('验收成功');
					// 重新获取详情
					dispatch('afterOpenDialog');
					// 重新获取列表
					dispatch('smsArrivalOrder/getList', {}, {root: true})
				}
			})
		},
		async multipleCheck({dispatch, commit, state}, payload) {
			const {detail: {deliveredOrderId}, multipleSelection} = state;
			if (multipleSelection.length <= 0) {
				return Message.error('至少选择一项进行批量验收');
			}
			await wait(dispatch, `sms.arrival-order.multiple-check`, async function() {
				const response = await check(deliveredOrderId, {
					checkList: multipleSelection.map((v) => {
						return {
							deliveredOrderGoodsId: v.recId,
							curCheckNum: v.curCheckNum,
							storageLocation: v.storageLocation
						}
					})
				});
				if (response.data) {
					Message.success('验收成功');
					if (response.data.completed) {
						dispatch('closeDialog');
						// 重新获取列表
						dispatch('smsArrivalOrderList/getList', {}, {root: true})
					} else {
						// 重新获取详情
						dispatch('afterOpenDialog');
					}
				}
			})
		},
		async updateShippingFee({dispatch, commit, state}, payload) {
			const {detail: {deliveredOrderId, shippingFee}} = state;
			await wait(dispatch, `sms.arrival-order.update-shippingfee`, async function () {
				const response = await updateShipFee(deliveredOrderId, {
					shippingFee: shippingFee
				});
				if (response.data) {
					Message.success('修改成功');
					dispatch('afterOpenDialog');
				}
			})
		},
		async updateShippingNo({dispatch, commit, state}, payload) {
			const {detail: {deliveredOrderId, shippingNo}} = state;
			await wait(dispatch, `sms.arrival-order.update-shippingNo`, async function () {
				const response = await updateShipNo(deliveredOrderId, {
					shippingNo: shippingNo
				});
				if (response.data) {
					Message.success('修改成功');
					dispatch('afterOpenDialog');
				}
			})
		},
		async updateInprice({dispatch, commit, state}, payload) {
			const {detail: {deliveredOrderId}, multipleSelection} = state;
			if (multipleSelection.length <= 0) {
				return Message.error('至少选择一项进行修改采购价');
			}
			await wait(dispatch, `sms.arrival-order.updateInprice`, async function () {
				const response = await updateInprice(deliveredOrderId, {
					goodsList: multipleSelection.map((v) => {
						return {
							deliveredOrderGoodsRecId: v.recId,
							inPrice: v.inPrice
						}
					})
				});
				if (response.data) {
					Message.success('修改成功');
					dispatch('afterOpenDialog');
				}
			})
		},
		async updateNum({dispatch, commit, state}, payload) {
			const {detail: {deliveredOrderId}, multipleSelection} = state;
			if (multipleSelection.length <= 0) {
				return Message.error('至少选择一项进行标记为缺货');
			}
			await wait(dispatch, `sms.arrival-order.updateNum`, async function () {
				const response = await updateNum(deliveredOrderId, {
					goodsList: multipleSelection.map((v) => {
						return {
							deliveredOrderGoodsRecId: v.recId,
							oosNum: v.oosNum
						}
					})
				});
				if (response.data) {
					Message.success('修改成功');
					dispatch('afterOpenDialog');
				}
			})
		},
		async cancelOrder({dispatch, commit, state}, payload) {
			const {detail: {deliveredOrderId}} = state;
			await wait(dispatch, `sms.arrival-order.cancel`, async function () {
				const response = await cancelOrder(deliveredOrderId, payload);
				if (response.code === 200) {
					Message.success('释放成功')
					dispatch('afterOpenDialog');
				} else {
					Message.success('释放失败')
				}
			})
		},
		async updateRemark({dispatch, commit, state}, payload) {
			const {detail: {deliveredOrderId, remark}} = state;
			await wait(dispatch, `sms.arrival-order.update-remark`, async function () {
				const response = await updateRemark({
					deliveredOrderId,
					remark
				});
				if (response.code === 200) {
					Message.success('修改成功');
					dispatch('afterOpenDialog');
				}
			})
		}
	},
	mutations: {
		updateList(state, payload) {
			state.list = state.list.map(item => {
				if (item.skuValue === payload.skuValue) {
					return payload
				} else {
					return item
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/arrival-order/detail.js